import React from 'react';
import CustomModal, { CustomModalContent, CustomModalFooter, ModalPrimaryButton, ModalSecondaryButton } from '../..';
import { ModalClose, useBCMSModal } from "@bcm-dev/bcms-vite";
import "./styles.css";

/**
 * @function SubmitDisputeTransactionModal
 * @return {React.Component}
 * @exported true
 * @description The submit dispute transaction modal
 */

export default function SubmitDisputeTransactionModal(props) {
  const hasData = props.data ? true : false;
  const hasOnConfirmClick = hasData ? (props.data.onConfirmClick ? true : false) : false;
  const confirmButtonDataPoint = { dataPoint: "Confirm_Button" };
  const { close } = useBCMSModal();

  const onConfirmClick = () => {
    if(hasOnConfirmClick) {
      close("SubmitDisputeTransactionModal");
      props.data.onConfirmClick();
    }
  };

  return(
    <CustomModal className="submit-dispute-transaction-modal" id="SubmitDisputeTransactionModal">
      <CustomModalContent>
          <p className="text-center">Are you ready to submit? Please confirm that your information is accurate and correct. 
          You will not be able to edit this later.</p>
      </CustomModalContent>
      <CustomModalFooter className="button-container">
          <ModalPrimaryButton text="Confirm" { ...confirmButtonDataPoint } onClick={ onConfirmClick }/>
          <ModalClose id="SubmitDisputeTransactionModal">
            <ModalSecondaryButton text="Cancel" />
          </ModalClose>
      </CustomModalFooter>
    </CustomModal>
  );
}